import { useTranslation } from "react-i18next";

import type { WebhookRegistration } from "../api";
import { WebhookRegistrationCard } from "./WebhookRegistrationCard";

import { Card } from "@/components/ui/v2/card";

interface WebhookRegistrationListProps {
  registrations: WebhookRegistration[];
  onDelete: (registrationId: string) => void;
  isDeleting: boolean;
  isLoading: boolean;
}

export function WebhookRegistrationList({
  registrations,
  onDelete,
  isDeleting,
  isLoading,
}: WebhookRegistrationListProps) {
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className="rounded-md border border-dashed border-border p-10 text-center text-sm text-muted-foreground">
        {t("common.loading")}
      </div>
    );
  }

  if (registrations.length === 0) {
    return (
      <div className="rounded-md border border-dashed border-border p-10 text-center text-sm text-muted-foreground">
        {t("common.noData")}
      </div>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {registrations.map((registration) => (
        <Card key={registration.id} className="p-4">
          <WebhookRegistrationCard
            registration={registration}
            onDelete={onDelete}
            isDeleting={isDeleting}
          />
        </Card>
      ))}
    </div>
  );
}
